var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shorthand)?_c('span',{class:_vm.shorthand.color},[_vm._v(" "+_vm._s(_vm.shorthand.expression)+" ")]):_c('date-tooltipped',_vm._b({attrs:{"iso-date":_vm.isoDate,"tooltipFormat":""}},'date-tooltipped',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }